import { AnimateStatus } from "@visactor/vrender-core/event/constant";

import { Step } from "../step";

export class ACustomAnimate extends Step {
    constructor(customFrom, customTo, duration, easing, params) {
        super("customAnimate", null != customTo ? customTo : {}, duration, easing), this.type = "customAnimate", 
        this.customFrom = customFrom, this.params = params, this.from = customFrom, this.to = customTo;
    }
    update(end, ratio, out) {
        if (this.onStart(), !this.props || !this.propKeys) return;
        const easedRatio = this.easing(ratio);
        this.onUpdate(end, easedRatio, out), this.syncAttributeUpdate();
    }
    setProps(props) {
        this.props = props, this.propKeys = Object.keys(props), this.animate.reSyncProps();
    }
}

export class AComponentAnimate extends ACustomAnimate {
    completeBind(animator) {
        this.setStartTime(0), this._animator && this._animator.start(), this.setDuration(animator.getDuration());
    }
    stop() {
        this._animator && this._animator.stop();
    }
}

export class AStageAnimate extends ACustomAnimate {
    constructor(customFrom, customTo, duration, easing, params) {
        super(customFrom, customTo, duration, easing, params), this.willCallBeforeStageRender = !0, 
        this.willCallAfterStageRender = !0, this.checkStatusAfterRender = !0, this._beforeStageRender = () => {
            if (!this.willCallBeforeStageRender) return;
            this.willCallBeforeStageRender = !1;
            const stage = this.target.stage, canvas = stage.window.getContext().canvas.nativeCanvas, outputCanvas = this.beforeStageRender(stage, canvas);
            outputCanvas && this.renderToStage(stage, outputCanvas);
        }, this._afterStageRender = () => {
            if (!this.willCallAfterStageRender) return;
            this.willCallAfterStageRender = !1;
            const stage = this.target.stage, canvas = stage.window.getContext().canvas.nativeCanvas, outputCanvas = this.afterStageRender(stage, canvas);
            outputCanvas && this.renderToStage(stage, outputCanvas), this.checkStatusAfterRender && this.animate.status === AnimateStatus.END && this.animate.timeline.removeAnimate(this.animate);
        }, this.props = {};
    }
    beforeStageRender(stage, canvas) {
        return !1;
    }
    afterStageRender(stage, canvas) {
        return !1;
    }
    onFirstRun() {
        super.onFirstRun(), this.target.stage.setBeforeRender(this._beforeStageRender), 
        this.target.stage.setAfterRender(this._afterStageRender), this.target.stage.disableDirtyBounds();
    }
    stop() {
        super.stop(), this.target.stage.removeBeforeRender(this._beforeStageRender), this.target.stage.removeAfterRender(this._afterStageRender);
    }
    onUpdate(end, ratio, out) {
        super.onUpdate(end, ratio, out), this.willCallBeforeStageRender = !0, this.willCallAfterStageRender = !0;
    }
    renderToStage(stage, canvas) {
        const stageCanvas = stage.window.getContext().canvas.nativeCanvas, ctx = stageCanvas.getContext("2d");
        return !!ctx && (ctx.clearRect(0, 0, stageCanvas.width, stageCanvas.height), ctx.drawImage(canvas, 0, 0), 
        stageCanvas);
    }
}
//# sourceMappingURL=custom-animate.js.map